import Link from "next/link";
import { useRouter } from "next/router";
import React, { useMemo } from "react";
import { useFetchUser } from "@anefi/services";
import { Modal } from "artisn-ui-react";

import { tabs } from "./ProfileNavigation.helpers";
import Styles from "./ProfileNavigation.styles";
import { ProfileNavigationProps as Props } from "./ProfileNavigation.types";
import useAuth from "contexts/auth/auth.context.hooks";
import useModals from "contexts/modals/modals.hooks";
import NaturalPath from "components/checkout/Checkout/NaturalPath/NaturalPath";
import LegalPath from "components/checkout/Checkout/LegalPath/LegalPath";

const ProfileNavigation: React.FC<Props> = props => {
  const { className } = props;
  const { pathname: currentPage } = useRouter();
  const { isAnonymous } = useAuth();
  const { showFirstInvestmentModal, setShowFirstInvestmentModal } = useModals();
  const auth = useAuth();
  const { data: user } = useFetchUser(auth);

  const selectPath = () => {
    if (user?.documentType === "CI") {
      return <NaturalPath />;
    }

    if (user?.documentType === "RUC") {
      return <LegalPath />;
    }
  };

  const onClose = () => {
    setShowFirstInvestmentModal(false);
  };

  const tabsToRender = useMemo(
    () =>
      tabs.filter(tab => {
        if (!tab) return false;
        const { authenticated } = tab;

        if (isAnonymous) {
          return !authenticated;
        }

        return true;
      }),
    [isAnonymous]
  );

  return (
    <Styles className={` ${className}`}>
      {tabsToRender.map((tab, index) => {
        if (!tab) return null;
        const { icon, tabName, url = "/", category } = tab;
        const { className, isExternal } = tab;

        if (isExternal) {
          return (
            <a
              key={index}
              className={`ProfileNavigation__tab ${
                currentPage.includes(url) ? "is-currently-active" : ""
              } ${className}`}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {icon}
              <p className="ProfileNavigation__tab-name">{tabName}</p>
            </a>
          );
        }

        return (
          <div key={index}>
            {category ? (
              <span className="ProfileNavigation__section">{category}</span>
            ) : null}

            {url === "/profile/user" ? (
              <>
                <div
                  className={`ProfileNavigation__tab ${
                    currentPage.includes(url) ? "is-currently-active" : ""
                  } ${className}`}
                  onClick={() => setShowFirstInvestmentModal(true)}
                >
                  {icon}
                  <p className="ProfileNavigation__tab-name">{tabName}</p>
                </div>
                <Modal
                  opened={showFirstInvestmentModal}
                  onClose={() => onClose()}
                  className="InvestFormButton__modal"
                  closeOnClickOutside={false}
                >
                  {selectPath()}
                </Modal>
              </>
            ) : (
              <Link href={url}>
                <div
                  className={`ProfileNavigation__tab ${
                    currentPage.includes(url) ? "is-currently-active" : ""
                  } ${className}`}
                >
                  {icon}
                  <p className="ProfileNavigation__tab-name">{tabName}</p>
                </div>
              </Link>
            )}
          </div>
        );
      })}
    </Styles>
  );
};

ProfileNavigation.defaultProps = {
  className: ""
};

export default ProfileNavigation;
